/**
 * Authentication Service
 * Handles authentication API calls
 */

import apiClient from '@/api/client';
import { API_ENDPOINTS } from '@/config/api.config';
import type { LoginRequest, LoginResponse } from '@/types/api.types';

/**
 * Login with policy number and PIN
 */
export const login = async (
  policyNumber: string,
  pin: string
): Promise<LoginResponse> => {
  const request: LoginRequest = {
    policyNumber: policyNumber.trim().toUpperCase(),
    pin: pin.trim(),
  };

  const response = await apiClient.post<LoginResponse>(
    API_ENDPOINTS.AUTH.LOGIN,
    request
  );

  return response.data;
};

/**
 * Validate JWT token
 */
export const validateToken = async (token: string): Promise<boolean> => {
  try {
    const response = await apiClient.post<{ valid: boolean }>(
      API_ENDPOINTS.AUTH.VALIDATE,
      JSON.stringify(token),
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data.valid;
  } catch (error) {
    return false;
  }
};
